<span class="flex" [ngStyle]='{ "transform": "scale("+scaleValue+")", margin: margin }'>
  <svg class="circle-loader" #svg="" [attr.width]="size" [attr.height]="size" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle [attr.cx]="center" [attr.cy]="center" [attr.r]="radius"></circle>
  </svg>
</span>